<template>
  <div id="kpi">
    <kpi-form :preset-gateway="$store.getters.gateway" preset-entity />

    <chart v-show="title"
           id="kpiChartLine"
           :title="title | capitalize"
           :kpi="kpi"
           :entity-id="entityId"
           :raw-data="rawData"
           :data-provider="dataProvider"
           :temporal-unit="temporalUnit"
    />
  </div>
</template>

<script>
import eventBus from '@/modules/eventBus'

import kpiMixin from '@/components/page/kpi/kpiMixin'
import KpiForm from '@/components/page/kpi/Form'
import Chart from '@/components/page/kpi/Chart'

export default {
  titleKey: 'gatewayKpi',

  components: { KpiForm, Chart },

  mixins: [kpiMixin],

  props: {
    eui: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      title: '',
      kpi: {},
      entityId: '',
      rawData: null,
      dataProvider: null,
      temporalUnit: 'HOUR'
    }
  },

  watch: {
    eui () {
      this.title = ''
    }
  },

  created () {
    // getKpi is defined is kpiMixin
    eventBus.$on('kpi:getKpi', this.getKpi)
  },

  destroyed () {
    eventBus.$off('kpi:getKpi', this.getKpi)
  }
}
</script>
